import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckBox from './CheckBox';

function AgreeToTermsCheckBox({ requiredFieldError, ...props }) {
  const { t } = useTranslation(['commonPlat']);
  return (
    <CheckBox
      {...props}
      requiredFieldError={requiredFieldError || t('commonPlat:errors.mustAgreeTerms')}
    />
  );
}

AgreeToTermsCheckBox._hookable = true;
AgreeToTermsCheckBox._dsgType = 'checkbox';

export default AgreeToTermsCheckBox;
